import { auth } from '../config/firebase'

export async function login(userType: UserType, password: string, authService = auth) {
  const email = `${userType.toLowerCase()}@gollygorillas.cool`

  const result = await authService.signInWithEmailAndPassword(email, password)
  return result.user
}